import { ActionTree } from 'vuex';
import { RootState } from '../..';
import {
  DashboardState,
  IItemDashboard,
  DashboardActions,
  DashboardMutations,
  IDashboardState,
  IDashboard,
  DashboardGetters,
  IFiltroLocal
} from './types';

export const actions: ActionTree<DashboardState, RootState> = {
  [DashboardActions.ATUALIZAR_NOME_ITEM_DASHBOARD](context, { id, updatedName } : IItemDashboard) {
    const item = context.getters[DashboardGetters.FIND_ITEM_GRID_LAYOUT](id);
    // @ts-ignore
    if (item && !Utils.isNullOrEmpty(updatedName)) {
      const { gridLayoutEditor } = context.state;

      const newState = gridLayoutEditor.map(itemLayout => itemLayout.i === item.i ? { ...itemLayout, label: updatedName } : itemLayout);

      context.commit(DashboardMutations.ATUALIZAR_GRID_LAYOUT_EDITOR, newState);
    }
  },
  [DashboardActions.SALVAR_DASHBOARD](context, newDashboard: IDashboardState) {
    const list = context.state.dashboardList;
    context.commit(DashboardMutations.ATUALIZAR_LISTA_DASHBOARD, [...list, { ...newDashboard, title: newDashboard.nome }]);
    context.commit(DashboardMutations.ATUALIZAR_NOME_DASHBOARD_ATUAL, '');
    context.commit(DashboardMutations.CLOSE_EDITOR_MODE);
    context.commit(DashboardMutations.ATUALIZAR_GRID_LAYOUT_EDITOR, []);
    context.commit(DashboardMutations.ATUALIZAR_DASHBOARD_SELECIONADA, newDashboard.key);
    context.commit(DashboardMutations.LIMPAR_LISTA_MODIFICACOES);
    context.commit(DashboardMutations.ATUALIZAR_IS_EDITAR, false);
  },
  [DashboardActions.SALVAR_DASHBOARD_EDITMODE](context, { id, layout, title }) {
    let list = context.state.dashboardList;
    const newDashboardList = list.map(dash => {
      if (dash.key === id) {
        dash.layout = layout;
        dash.title = title;
      }
      return dash;
    });

    context.commit(DashboardMutations.ATUALIZAR_LISTA_DASHBOARD, newDashboardList);
  },
  [DashboardActions.REMOVER_DASHBOARD]({ state, commit, getters }, id: number) {
    const list = state.dashboardList;

    const dashboardDelete = getters[DashboardGetters.FIND_DASHBOARD_BY_ID](id);

    // Não pode deletar a dash que contem isDefault como true
    if (dashboardDelete.isDefault) return;

    const newList = list.filter((dash: IDashboard) => dash.id !== id);
    commit(DashboardMutations.ATUALIZAR_LISTA_DASHBOARD, newList);
    commit(DashboardMutations.ATUALIZAR_DASHBOARD_SELECIONADA, getters[DashboardGetters.FIND_DEFAULT_DASHBOARD]);
  },
  [DashboardActions.ADICIONAR_FILTRO_LOCAL]({ state, commit, getters }, payload: IFiltroLocal) {
    const list = state.filtrosLocaisPreenchidos;
    const filtro = getters[DashboardGetters.FIND_LOCAL_FILTER](payload.i);

    if (filtro) {
      const newList = list.filter(filtro => filtro.i !== payload.i);

      commit(DashboardMutations.ATUALIZAR_LISTA_FILTROS_LOCAIS_PREENCHIDOS, [...newList, payload]);
    } else {
      commit(DashboardMutations.ATUALIZAR_LISTA_FILTROS_LOCAIS_PREENCHIDOS, [...list, payload]);
    }
  },
  [DashboardActions.REMOVER_FILTRO_LOCAL]({ state, commit, getters }, payload: number) {
    const filtro = getters[DashboardGetters.FIND_LOCAL_FILTER](payload);

    if (filtro) {
      const list = state.filtrosLocaisPreenchidos;

      const newList = list.filter(filtro => filtro.i !== payload);
      commit(DashboardMutations.ATUALIZAR_LISTA_FILTROS_LOCAIS_PREENCHIDOS, newList);
    }
  },
  [DashboardActions.ATUALIZAR_DASHBOARD_PADRAO]({ state, commit }, payload: string) {
    const listDashboard = state.dashboardList.map((dashboard: IDashboard) => {
      if (dashboard.isDefault) {
        return { ...dashboard, isDefault: false };
      } else if (dashboard.key === payload) {
        return { ...dashboard, isDefault: true };
      }

      return dashboard;
    });

    commit(DashboardMutations.ATUALIZAR_LISTA_DASHBOARD, listDashboard);
  }
};
